import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { ENUM__settings_user_tab } from '@/pages/+settings/user/_base/ENUM__settings_user_tab';
import { ESettingsWorkspaceTab } from '@/pages/+settings/workspace/ESettingsWorkspaceTab';
import { ENUM__image_compare_mode } from '@/pages/_base/grid2d_sidebar_image_compare/ENUM__image_compare_mode';
import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { ENUM__image_brush } from '@/pages/page_generation/layouts/assets_images/_base/ENUM__image_brush';
import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { createSlice } from '@reduxjs/toolkit';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DTO__generation_inputs_filter } from '@shared/dto/generation/DTO__generation_inputs_filter';
import { DTO_META__field_info } from '@shared/dto/generation/graph_invoke/_fields/_base/DTO_META__field_info';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { ENUM__generation_output_type } from '@shared/dto/generation/graph_invoke/_templates/_enums/ENUM__generation_output_type';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { Position } from '@xyflow/react';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../_base/LOCAL__global_reset';
import { INIT_LOCAL__ui_put_set_of_strings } from './_base/LOCAL__ui_put_set_of_strings';
import { INIT_LCAL__ui_set_boolean } from './_base/LOCAL__ui_set_boolean';
import { INIT_LOCAL__ui_set_image } from './_base/LOCAL__ui_set_image';
import { INIT_LOCAL__ui_set_number } from './_base/LOCAL__ui_set_number';
import { INIT_LOCAL__ui_set_string } from './_base/LOCAL__ui_set_string';
import { INIT_LOCAL__ui_drag_and_drop_set_hovered_graph_field } from './drag_and_drop/LOCAL__ui_drag_and_drop_set_hovered_graph_field';
import { INIT_LOCAL__ui_drag_and_drop_set_image_dragged } from './drag_and_drop/LOCAL__ui_drag_and_drop_set_image_dragged';
import { INIT_LOCAL__ui_g_general__sidebar_field_hovered_set } from './generation/LOCAL__ui_g_general__sidebar_field_hovered_set';
import { INIT_LOCAL__ui_g_inputs__filter_set } from './generation/LOCAL__ui_g_inputs__filter_set';
import { INIT_LOCAL__ui_generation_graph_set_field_to_create_new_edge } from './generation/LOCAL__ui_generation_graph_set_field_to_create_new_edge';
import { INIT_LOCAL__ui_generation_graph_set_hovered_field } from './generation/LOCAL__ui_generation_graph_set_hovered_field';
import { INIT_LOCAL__ui_generation_grid2d_set_hovered_dimensions } from './generation/LOCAL__ui_generation_grid2d_set_hovered_dimensions';
import { INIT_LOCAL__ui_generation_output_image_preview_set } from './generation/LOCAL__ui_generation_output_image_preview_set';
import { INIT_LOCAL__ui_generation_set_hovered_button_grid2d_dimension } from './generation/LOCAL__ui_generation_set_hovered_button_grid2d_dimension';
import { init_local_ui_hint_shortcut_hide } from './hint_shortcut/local_ui_hint_shortcut_hide';
import { init_local_ui_hint_shortcut_show } from './hint_shortcut/local_ui_hint_shortcut_show';
import { init_local_ui_set_key_is_shift_pressed } from './hotkeys/local_ui_set_key_is_shift_pressed';
import { INIT_LOCAL__ui_grids2d_set_current_cell } from './image/LOCAL__ui_grids2d_set_current_cell';
import { INIT_LOCAL__ui_grids2d_set_current_cell_neigbours } from './image/LOCAL__ui_grids2d_set_current_cell_neigbours';
import { INIT_LOCAL__ui_set_field_for_generation_layout } from './image/LOCAL__ui_set_field_for_generation_layout';
import { init_local_ui_page_tasks_set_new_task_id } from './page_tasks/local_ui_page_tasks_set_new_task_id';
import { STATE__ui } from './STATE__ui';

export const slice_ui_initial_state: STATE__ui = {
  /*
   * INTERACTION
   */
  global__commands_list_visible: false,
  global__is_app_on_focus: true,
  global__is_shift_pressed: false,

  /*
   * GLOBAL
   */
  global__page_type: '',
  global__fps: 0,

  // this app developed for desktop by default
  global_is_desktop: false, //todo: use enum
  global_is_mobile: false, //todo: use enum
  global_is_tablet: false, //todo: use enum

  global_need_show_first_animation: false,

  global_images_selected_hashes: new Set(),
  global_images_on_screen_hahses: new Set(),

  global__hide_sidebars: false,
  global__grid2d_show_as_gallery: false,
  global__grid2d_gallery_cell_current: DTO__grid2d_cell.CREATE_STUB(),
  global__grid2d_gallery_cell_neigbours: [],

  /*
   *
   */
  grid2d_image_compare__mode: ENUM__image_compare_mode.NONE,
  grid2d_image_compare__image_a: DTO__image_asset.CREATE_STUB(),
  grid2d_image_compare__use_image_a_asperation_ratio: false,

  /*
   * DRAG AND DROP
   */

  drag_and_drop__image_internal_zones_show: false,
  drag_and_drop__image_internal_dragged: DTO__image_asset.CREATE_STUB(),

  drag_and_drop__image_external_zones_show: false,
  drag_and_drop__image_external_zone_hovered_graph_field: FIELD__base.CREATE_STUB(),

  /*
   * AUTH
   */

  page_auth_show_email_is_not_verified: false,
  page_auth_show_magic_link_sent: false,

  page_auth_is_loading: false,

  /*
   * COLLECTIONS
   */

  page_collections_hide_unused: true,
  page_collections_cells_dragged: [],
  page_collections_cells_selected: [],
  page_collection_cell_hovered: DTO__grid2d_cell.CREATE_STUB(),

  /*
   * DIFFUSION MODELS
   */

  page_diffusion_models_table_row_hovered_id: '',

  /*
   * GENERATION
   */

  /*
   * GENERAL
   */

  g_general__layout: ENUM__page_generation_layout.OUTPUTS,
  g_general__ui_disabled: false,

  g_general__sidebar_field_hovered: FIELD__base.CREATE_STUB(),

  g_general__field_to_add_special_tokens: FIELD__list_token.CREATE_STUB(),

  /*
   * LAYOUT GRAPH
   */
  g_graph__edge_id_selected: ENUM__string_id_empty.UUID,
  g_graph__node_id_selected: ENUM__string_id_empty.UUID,
  g_graph__node_id_hovered: ENUM__string_id_empty.UUID,
  //
  g_graph__field_hovered: DTO_META__field_info.CREATE_STUB(),
  //
  g_graph__new_edge_field: FIELD__base.CREATE_STUB(),
  g_graph__new_edge_field_position: '' as Position,
  //
  g_graph__show_hashes: true, //todo:change to false

  /*
   * LAYOUT IMAGE EDIT
   */
  g_image_edit__tab: ENUM__page_generation_layout_images_edit_tab.SEGMENTS, //todo: change to view
  g_image_edit__field: FIELD__image_asset.CREATE_STUB(),

  //
  g_image_edit__brush: ENUM__image_brush.POINTER,
  g_image_edit__brush_size: CONSTANTS__client.IMAGE_BRUSH_SIZE_RANGE.get_average(),

  g_image_edit__select__image_asset: DTO__image_asset.CREATE_STUB(),
  g_image_edit__replace__workspace_id: ENUM__string_id_empty.OBJECT_ID,
  g_image_edit__replace__category: ENUM__image_asset_category.IMAGE,

  /*
   *
   */

  g_inputs__filter: new DTO__generation_inputs_filter(),
  g_inputs__fields_ids_selected: new Set(),

  /*
   * LAYOUT OUTPUT
   */
  g_tools__output_type: ENUM__generation_output_type.IMAGE,
  g_output__image_asset_preview: DTO__image_asset.CREATE_STUB(),

  //todo:rename prefix grid2d -> output
  g_grid2d__consume__hash_sha256_content: ENUM__string_id_empty.HASH_SHA256,
  g_grid2d__token_edit: FIELD__token.CREATE_STUB(),

  /*
   * TODO: REVIEW
   */

  g_is_grid2d_dragging: false,

  g_dragging_invocation_type: '',

  g_hovered_grid2d_column: FIELD__base.CREATE_STUB(),
  g_hovered_grid2d_row: FIELD__base.CREATE_STUB(),

  g_hovered_grid2d_dimension_from_grid: false,

  //todo: review
  open_pose_body_size: 50,
  /*
   * HINTS SHORTCUTS
   */
  hints_shortcut_visible: [],
  hints_shortcut_overlay_with_all_values_visible: false,

  /*
   * SEARCH
   */
  page_search_show_history: false,
  page_search_hide_unused: true,

  /*
   * SETTINGS
   */

  page_settings_user_current_tab: ENUM__settings_user_tab.ACCOUNT,
  page_settings_workspace_current_tab: ESettingsWorkspaceTab.GENERAL,

  /*
   * TASKS
   */

  page_tasks_hide_unused: true,
  page_tasks_new_task_id: ENUM__string_id_empty.OBJECT_ID,

  /*
   * OPEN POSE
   */

  is_service_open_pose_init: false,
};

function add_reducer(map: Record<string, any>, action: string, reducer: any) {
  map[action.remove_first_part_of_path()] = reducer;
}

const ENUM = ENUM__redux_action;

const reducers: Record<string, any> = {};

add_reducer(reducers, ENUM.UI_GENERATION_OUTPUT_IMAGE_PREVIEW_SET, INIT_LOCAL__ui_generation_output_image_preview_set);
add_reducer(reducers, ENUM.UI_GENERATION_INPUTS__FILTER_SET, INIT_LOCAL__ui_g_inputs__filter_set);

add_reducer(reducers, ENUM.UI_DRAG_AND_DROP_SET_HOVERED_GRAPH_FIELD, INIT_LOCAL__ui_drag_and_drop_set_hovered_graph_field);
add_reducer(reducers, ENUM.UI_DRAG_AND_DROP_SET_IMAGE_DRAGGED, INIT_LOCAL__ui_drag_and_drop_set_image_dragged);
add_reducer(reducers, ENUM.UI__IMAGE__SET_FIELD_FOR_GENERATION_LAYOUT, INIT_LOCAL__ui_set_field_for_generation_layout);
add_reducer(reducers, ENUM.UI_GENERATION_GENERAL__SIDEBAR_FIELD_HOVERED_SET, INIT_LOCAL__ui_g_general__sidebar_field_hovered_set);
add_reducer(reducers, ENUM.UI_GENERATION_GRID2D_SET_HOVERED_DIMENSIONS, INIT_LOCAL__ui_generation_grid2d_set_hovered_dimensions);
add_reducer(reducers, ENUM.UI__GRID2D__SET_CURRENT_CELL, INIT_LOCAL__ui_grids2d_set_current_cell);
add_reducer(reducers, ENUM.UI__GRID2D__SET_CURRENT_CELL_NEIGBOURS, INIT_LOCAL__ui_grids2d_set_current_cell_neigbours);

add_reducer(reducers, ENUM.UI_SET_IMAGE, INIT_LOCAL__ui_set_image);

export const slice_ui = createSlice({
  name: ENUM__redux_slice.UI,
  initialState: slice_ui_initial_state,
  reducers: {
    ...reducers,
    key_set_is_shift_pressed: init_local_ui_set_key_is_shift_pressed,

    set_boolean: INIT_LCAL__ui_set_boolean,
    set_number: INIT_LOCAL__ui_set_number,
    set_string: INIT_LOCAL__ui_set_string,
    put_set_of_strings: INIT_LOCAL__ui_put_set_of_strings,

    generation_graph_set_field_to_create_new_edge: INIT_LOCAL__ui_generation_graph_set_field_to_create_new_edge,
    generation_graph_set_hovered_field: INIT_LOCAL__ui_generation_graph_set_hovered_field,
    generation_set_button_grid2d_dimension_hovered: INIT_LOCAL__ui_generation_set_hovered_button_grid2d_dimension,

    page_tasks_set_new_task_id: init_local_ui_page_tasks_set_new_task_id,

    hint_shortcut_show: init_local_ui_hint_shortcut_show,
    hint_shortcut_hide: init_local_ui_hint_shortcut_hide,
  },

  extraReducers: builder => {
    builder.addCase(LOCAL__global_reset, state => {
      return {
        ...slice_ui_initial_state,
        global_is_desktop: state.global_is_desktop,
        global_is_mobile: state.global_is_mobile,
        global_is_tablet: state.global_is_tablet,
      };
    });
  },
});
